export const resetErrors = (dispatch, actions) => {
  dispatch(actions.setResetError(''));
  dispatch(actions.setResetErrors({}));
};